import { UserData } from './interfaces';

export const formatProducts = (products: any, additionalItems?: boolean) => {
	return products.flat().reduce((acc: any, product: any) => {
		if (product.productType === 'COMBO') {
			product.productsInCombo.forEach((p: any) => {
				const GAChildProduct: Record<string, unknown> = {
					item_id: p.ean13,
					item_name: p.description,
					item_variant: product?.businessUnitName || '',
					price: p.unitPricePromotion,
					quantity: p.quantity,
					discount: p.unitDiscount,
					affiliation: product.affiliation,
					promotion_id: product.hyperaCode || '',
					promotion_name: product.description,
					industry_name: product?.businessUnitName ? 'Hypera' : product?.industryName!,
					...(additionalItems ? { minimum_value: product.minimum_value } : {}),
				};

				if (p.suggestionGroupName) GAChildProduct.item_list_name = p.suggestionGroupName;

				acc.push(GAChildProduct);
			});

			return acc;
		}

		const GAProduct: Record<string, unknown> = {
			item_id: product.ean13,
			item_name: product.description,
			item_variant: product?.businessUnitName || '',
			price: product.unitPricePromotion,
			quantity: product.quantity,
			discount: product.unitDiscount,
			affiliation: product.affiliation,
			industry_name: product?.businessUnitName ? 'Hypera' : product?.industryName!,
			...(additionalItems ? { minimum_value: product.minimum_value } : {}),
		};

		if (product.suggestionGroupName) GAProduct.item_list_name = product.suggestionGroupName;

		acc.push(GAProduct);

		return acc;
	}, []);
};

export const buildUserData = ({
	name,
	email,
	phoneNumber,
	phoneNumberConfirmed,
	street,
	city,
	region,
	postalCode,
}: {
	name?: string;
	email?: string;
	phoneNumber?: string | null;
	phoneNumberConfirmed?: boolean;
	street?: string;
	city?: string;
	region?: string;
	postalCode?: string;
}): UserData => {
	const [first_name, ...rest] = name?.trim().split(' ') || [];
	const hasAddressData = !!(name || street || city || region || postalCode);

	return {
		email: email || undefined,
		phone_number: phoneNumberConfirmed && phoneNumber ? `+55${phoneNumber}` : undefined,
		address: hasAddressData
			? {
					first_name: first_name || undefined,
					last_name: rest.join(' ') || undefined,
					street: street || undefined,
					city: city || undefined,
					region: region || undefined,
					postal_code: postalCode || undefined,
					country: 'BR',
			  }
			: undefined,
	};
};

export const handlePushEvent = <T extends Record<string, any>>(name: string, params?: T) => {
	try {
		if (!name) throw new Error('A "name" is required');

		const event = {
			event: name,
			...params,
		};

		window.dataLayer ??= [];
		window.dataLayer.push(event);

		// console.log('Event Sent:', name, params);
	} catch (error) {
		console.error('Error on push event', error);
	}
};
